import { z } from 'zod'

export const loginSchema = z.object({
  email: z.email('Email je v neplatnom tvare').min(1, 'Email je povinný'),
  password: z.string().min(1, 'Heslo je povinné'),
})

export type LoginSchema = z.infer<typeof loginSchema>
